import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({setFilters, filters, boName}) => {
    const {boXRayStatus, boXRayResponsible, boXRayReasons, boXRayTeam, boXRayNeighborhood, boXRayStreets, boXRayConditions} = useReportFiltersFetch({fetchBOStatus: true, fetchBOXrayResponsible: true, fetchBOXrayReason: true, fetchBOXrayTeam: true, fetchBOXrayNeighborhoods: true, fetchBOXrayStreets: true, fetchBOXrayConditions: true})

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                     <InputDateTime
                         id="dtStart"
                         label="Data/hora inicial *"
                         selected={filters.dtStart}
                         onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                         classNameWrapper={"w-full"}
                         dateFormat="LL"
                     />

                     <InputDateTime
                         id="dtEnd"
                         label="Data/hora final *"
                         selected={filters.dtEnd}
                         onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                         classNameWrapper={"w-full"}
                         dateFormat="LL"
                     />

                     <SelectComponent
                         label={`Status do ${boName}`}
                         isMulti={true}
                         wrapValues={true}
                         options={boXRayStatus}
                         value={filters.statusBo}
                         onChange={(value) => setFilters(prev => ({...prev, statusBo: value}))}
                         instanceId="statusBo"
                         classNameWrapper={"w-full"}
                     />

                     <SelectComponent
                         label='Responsável'
                         isMulti={true}
                         wrapValues={true}
                         options={boXRayResponsible}
                         value={filters.responsible}
                         onChange={(value) => setFilters(prev => ({...prev, responsible: value}))}
                         instanceId="responsible"
                         classNameWrapper={"w-full"}
                     />

                    <SelectComponent
                         label='Condição dos indivíduos'
                         isMulti={true}
                         wrapValues={true}
                         options={boXRayConditions}
                         value={filters.condition}
                         onChange={(value) => setFilters(prev => ({...prev, condition: value}))}
                         instanceId="condition"
                         classNameWrapper={"w-full"}
                     />

                     <SelectComponent
                         label='Natureza'
                         isMulti={true}
                         wrapValues={true}
                         options={boXRayReasons}
                         value={filters.reason}
                         onChange={(value) => setFilters(prev => ({...prev, reason: value}))}
                         instanceId="reason"
                         classNameWrapper={"w-full"}
                     />

                     <SelectComponent
                         label='Equipe'
                         isMulti={true}
                         wrapValues={true}
                         options={boXRayTeam}
                         value={filters.team}
                         onChange={(value) => setFilters(prev => ({...prev, team: value}))}
                         instanceId="team"
                         classNameWrapper={"w-full"}
                     />

                     <SelectComponent
                         label='Flagrante'
                         isMulti={false}
                         wrapValues={true}
                         options={[
                             {label: "Sim", value: 'true'},
                             {label: "Não", value: 'false'}
                         ]}
                         value={filters.flagrant}
                         onChange={(value) => setFilters(prev => ({...prev, flagrant: value}))}
                         instanceId="flagrant"
                         classNameWrapper={"w-full"}
                         isClearable={true}
                     />

                     <SelectComponent
                         label='Bairro'
                         isMulti={true}
                         wrapValues={true}
                         options={boXRayNeighborhood}
                         value={filters.neighborhood}
                         onChange={(value) => setFilters(prev => ({...prev, neighborhood: value}))}
                         instanceId="neighborhood"
                         classNameWrapper={"w-full"}
                     />

                     <SelectComponent
                         label='Logradouro'
                         isMulti={true}
                         wrapValues={true}
                         options={boXRayStreets}
                         value={filters.street}
                         onChange={(value) => setFilters(prev => ({...prev, street: value}))}
                         instanceId="street"
                         classNameWrapper={"w-full"}
                     />

                </form>
            </div>
        </>
    );
};

export default Filters;